import { render } from "./ReplayPage.vue?vue&type=template&id=a623bd84&scoped=true"
import script from "./ReplayPage.vue?vue&type=script&lang=js"
export * from "./ReplayPage.vue?vue&type=script&lang=js"

import "./ReplayPage.vue?vue&type=style&index=0&id=a623bd84&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a623bd84"]])

export default __exports__